<template>
  <div>
    <b-link v-b-modal="modalId">
      Ko'rish
    </b-link>
    <b-modal
      :id="modalId"
      title="Nogironlik guvohnomasi"
      hide-footer
      size="lg"
    >
      <table class="table">
        <tr
          v-for="field in Object.keys(data)"
          :key="field"
        >
          <th> {{ field }}</th>
          <td>
            {{ data[field] }}
          </td>
        </tr>
      </table>
    </b-modal>
  </div>
</template>

<script>
import { VBModal, BLink } from 'bootstrap-vue'

export default {
  name: 'ShowDisabilityDataComponent',
  directives: {
    'b-modal': VBModal,
  },
  components: {
    BLink,
  },
  props: {
    data: {
      type: Object,
    },
    modalId: {
      type: String,
      default: () => 'show-disability-data',
    },
  },
}
</script>

<style scoped>

</style>
